export const SETUP_RECOMMENDATION_PREVIEW_LIMIT = 4

/**
 * Product capabilities that can be configured after a template is selected.
 * Emoji are intentionally presentation-only and can later be replaced with
 * product icons without changing recommendation ids or analytics.
 */
export const SETUP_FEATURES = [
    {
        id: 'lead_form',
        icon: '📝',
        title: 'Lead form',
        description: 'Add a standalone form to collect contact details, surveys, or feedback.',
        order: 0,
        helpUrl: 'https://help.interacty.me/en/content/how-to-create-a-lead-form',
        tileIds: ['goal_collect_leads', 'leads_basic_contact', 'leads_custom_form', 'leads_consent'],
        excludeWhenTileIds: ['leads_before_game', 'leads_after_game'],
        descriptionPhrases: [
            'standalone lead form',
            'standalone form',
            'survey form',
            'feedback form',
            'отдельная лид-форма',
            'опрос',
            'обратная связь',
        ],
    },
    {
        id: 'in_game_lead_form',
        icon: '🎮',
        title: 'In-game lead form',
        description: 'Collect participant details before or after the game.',
        order: 1,
        helpUrl: 'https://help.interacty.me/en/content/how-to-add-a-lead-form-to-a-game',
        tileIds: ['leads_before_game', 'leads_after_game'],
        descriptionPhrases: [
            'lead form in game',
            'in-game lead form',
            'before the game',
            'after the game',
            'collect leads in game',
            'форма внутри игры',
            'до игры',
            'после игры',
        ],
    },
    {
        id: 'rewards',
        icon: '🎁',
        title: 'Rewards',
        description: 'Configure a limited inventory of valuable prizes and track their distribution.',
        order: 2,
        helpUrl: 'https://help.interacty.me/en/content/giveaways',
        tileIds: ['rewards_limited_inventory'],
        descriptionPhrases: [
            'limited prizes',
            'physical prizes',
            'prize inventory',
            'finite prizes',
            'ограниченное количество призов',
            'ценные призы',
            'физические призы',
        ],
    },
    {
        id: 'multiplayer_event',
        icon: '📱',
        title: 'Multiplayer event',
        description: 'Run a live game where participants join and compete simultaneously.',
        order: 3,
        helpUrl: 'https://help.interacty.me/en/content/online-game-event',
        tileIds: [
            'participation_host_led',
            'participation_participant_phones',
            'participation_team_game',
            'device_participant_phones',
        ],
        descriptionPhrases: [
            'multiplayer',
            'real-time game',
            'live game',
            'hosted game',
            'join by phone',
            'participant phones',
            'team competition',
            'мультиплеер',
            'телефон',
            'команд',
            'ведущ',
        ],
    },
    {
        id: 'leaderboards',
        icon: '🏆',
        title: 'Leaderboards',
        description: 'Show player rankings and track game results.',
        order: 4,
        helpUrl: 'https://help.interacty.me/en/content/leaderboards-statistics-leads',
        tileIds: ['mechanic_leaderboard'],
        descriptionPhrases: ['leaderboard', 'player ranking', 'scoreboard', 'таблица лидеров', 'рейтинг игроков'],
    },
    {
        id: 'website_embed',
        icon: '🌐',
        title: 'Website embed',
        description: 'Add the finished event to your website.',
        order: 5,
        helpUrl: 'https://help.interacty.me/en/content/embed',
        tileIds: ['integration_embed'],
        descriptionPhrases: ['embed', 'iframe', 'website', 'встроить', 'сайт', 'айфрейм'],
    },
    {
        id: 'webhook_crm',
        icon: '🔗',
        title: 'Webhook or CRM',
        description: 'Send collected leads to your external system.',
        order: 6,
        helpUrl: 'https://help.interacty.me/en/content/how-to-set-up-a-webhook-for-your-lead-form',
        tileIds: ['integration_crm', 'integration_webhook'],
        descriptionPhrases: ['webhook', 'crm', 'mailchimp', 'api', 'вебхук'],
    },
    {
        id: 'custom_domain',
        icon: '🔤',
        title: 'Custom domain',
        description: 'Publish the event on your own domain.',
        order: 7,
        helpUrl: 'https://help.interacty.me/en/content/custom-domain-cname',
        tileIds: ['integration_custom_domain'],
        descriptionPhrases: ['custom domain', 'own domain', 'домен'],
    },
    {
        id: 'external_analytics',
        icon: '📈',
        title: 'External analytics',
        description: 'Track campaign performance in your analytics tools.',
        order: 8,
        helpUrl: 'https://help.interacty.me/en/content/how-can-i-embed-a-meta-pixel-facebook-pixel-into-my-project',
        tileIds: ['integration_external_analytics'],
        descriptionPhrases: ['google analytics', 'external analytics', 'tracking', 'аналитик', 'метрик'],
    },
]
